module.exports = require('norska-frontend/lib/lazyload');
